module.exports = __webpack_public_path__ + "assets/canva-mini-icon.4ba03b9d.svg";